<template>
    <div id="subjectAddEdit">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="学校Logo" prop="logo">
                        <uploader ref="coverUploader" pathPrefix="moduleApp"
                                  :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif','svg']" showResult="image" openDelete
                                  showMode="button" v-model="logo"></uploader>
                    </el-form-item>
                    <el-form-item label="课程名称" prop="name">
                        <el-input v-model="formData.name" :maxlength="45" placeholder="请输入课程名称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="课程简称" prop="otherName">
                        <el-input v-model="formData.otherName" :maxlength="20" placeholder="请输入课程简称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="课程编码" prop="code">
                        <el-input v-model="formData.code" :maxlength="11" placeholder="请输入课程编码"
                                  @blur="formData.code = formData.code.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="国标课程">
                        <el-switch
                            v-model="formData.isNS" :active-value="1" :inactive-value="2">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="学科类型" prop="isMain">
                        <el-select size="medium" v-model="formData.isMain" placeholder="请选择">
                            <el-option :value="2" label="主学科"></el-option>
                            <el-option :value="1" label="综合学科"></el-option>
                            <el-option :value="3" label="校本学科"></el-option>
                            <el-option :value="4" label="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学段" prop="level">
                        <el-select size="medium" v-model="formData.level" placeholder="请选择">
                            <el-option :value="0" label="其他"></el-option>
                            <el-option :value="1" label="幼儿园"></el-option>
                            <el-option :value="2" label="小学"></el-option>
                            <el-option :value="3" label="初中"></el-option>
                            <el-option :value="4" label="高中"></el-option>
                            <el-option :value="7" label="大中专"></el-option>
                            <el-option :value="10" label="特殊教育"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试类型" prop="examType">
                        <el-select size="medium" v-model="formData.examType" placeholder="请选择">
                            <el-option :value="1" label="考试"></el-option>
                            <el-option :value="2" label="考查"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="order">
                        <el-input-number  size="medium" :step="1"  v-model="formData.order" :precision="0" :min="1" :max="9999"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';
    import {queryCurriculumDetail, addCurriculum, editCurriculum} from '@/api/subjectManagement';
    import mixin from '@/mixins/windowResize';

    export default {
        name: 'subjectAddEdit',
        components: {Uploader},
        data() {

            return {
                formData: {
                    bussinessNumber: '',
                    managerEmail: '',
                    managerMobile: '',
                    otherName: '',
                    code: '',
                    isMain: 2,
                    level: 0,
                    name: '',
                    examType: 1,
                    isNS: 2,
                    order:1
                },
                rules: {
                    name: [
                        {required: true, message: '请输入课程名', trigger: 'blur'},
                    ],
                    otherName: [
                        {required: true, message: '请输入课程简称', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, message: '请输入课程编码', trigger: 'blur'},
                    ],
                    isMain: [
                        {required: true, message: '请选择学科类型', trigger: 'blur'},
                    ],
                    level: [
                        {required: true, message: '请选择学段', trigger: 'blur'},
                    ],
                    examType: [
                        {required: true, message: '请选择考试类型', trigger: 'blur'},
                    ],
                    order: [
                        {required: true, message: '请输入排序', trigger: 'blur'},
                    ],
                },
                id: this.$route.query.id,
                isEdit: !!this.$route.query.id,
                logo: [],
                moduleTypeList: [],

            }
        },
        mixins: [mixin],
        created() {
            if (this.isEdit) {
                queryCurriculumDetail({
                    id: this.id
                })
                    .then(data => {
                        data.isNS = data.isNS ? data.isNS : 2;
                        this.formData = data;
                        if(data.logoUrl) {
                            this.logo = [{
                                fileUrl: data.logoUrl
                            }]
                        }
                    })
            }
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        const args  = {
                            examType: this.formData.examType,
                            isMain: this.formData.isMain,
                            level: this.formData.level,
                            logoUrl: this.logo.length !== 0 ? this.logo[0].fileUrl : 'https://wxtestpb-10048617.image.myqcloud.com/70dde043-1baf-4c5e-9114-bfd1d41641ee?imageView2/q/100/w/800',
                            name: this.formData.name,
                            otherName: this.formData.otherName,
                            code: this.formData.code,
                            isNS: this.formData.isNS,
                            order:this.formData.order
                        };
                        new Promise(resolve => {
                            if(this.isEdit) {
                                args.id = this.id;
                                editCurriculum(args)
                                    .then(resolve)
                            } else {
                                addCurriculum(args)
                                    .then(resolve)
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                setTimeout(() => {
                                    this.$router.back();
                                }, 1000);
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    #subjectAddEdit {
        padding: 12px;

        .logo-image {
            height: 100px;
            margin-right: 10px;
            float: left;
        }

        .top {
            border-bottom: 1px solid #e7eaec;
            padding-bottom: 10px;
        }

        .body {
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/systemData/subjectManagement/subjectAddEdit.vue